// Curated cinematic imagery (Unsplash / Pexels, high-quality, non mass-market)
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  aviation: "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  yacht: "https://images.unsplash.com/photo-1598737285721-29346a5c9278?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  chauffeur: "https://images.unsplash.com/photo-1740098160485-d098fbf42814?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  villa: "https://images.unsplash.com/photo-1613977257363-707ba9348227?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  coastline: "https://images.unsplash.com/photo-1562532418-ad84d8df5124?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  concierge: "https://images.unsplash.com/photo-1551516594-56cb78394645?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  membership: "https://images.unsplash.com/photo-1590490360182-c33d57733427?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  marrakech: "https://images.unsplash.com/photo-1778752780886-b7a612163778?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  moroccoDesert: "https://images.unsplash.com/photo-1553522988-49daec855a59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  saintTropez: "https://images.pexels.com/photos/29851512/pexels-photo-29851512.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  dubai: "https://images.unsplash.com/photo-1605310723314-fb5fc44534cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  amalfi: "https://images.unsplash.com/photo-1578508100537-30a3fca93b9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  maldives: "https://images.pexels.com/photos/9394274/pexels-photo-9394274.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  courchevel: "https://images.unsplash.com/photo-1709508496457-e2f9c42493c6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sardinia: "https://images.unsplash.com/photo-1617365161828-9cf0f14e25b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  monaco: "https://images.unsplash.com/photo-1581819896533-f8ab6767ce7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Ordered to match destinations.list (identical order across all languages)
export const DESTINATION_ORDERED = [
  IMAGES.coastline,   // 0 Mallorca
  IMAGES.yacht,       // 1 Ibiza
  IMAGES.coastline,   // 2 Formentera
  IMAGES.villa,       // 3 Marbella
  IMAGES.monaco,      // 4 Monaco
  IMAGES.saintTropez, // 5 Saint-Tropez
  IMAGES.coastline,   // 6 Mykonos
  IMAGES.chauffeur,   // 7 London
  IMAGES.concierge,   // 8 Paris
  IMAGES.dubai,       // 9 Dubai
  IMAGES.courchevel,  // 10 Switzerland
  IMAGES.marrakech,   // 11 Marrakech (Morocco)
  IMAGES.sardinia,    // 12 Sardinia
  IMAGES.amalfi,      // 13 Amalfi
  IMAGES.yacht,       // 14 St. Barths
  IMAGES.maldives,    // 15 Maldives
  IMAGES.courchevel,  // 16 Courchevel
];
